<script setup lang="ts">
import type { OnActiveItem } from './ProductSelectItems.vue'
export type { OnActiveItem } from './ProductSelectItems.vue'

type ProductPartial = Pick<ProductListingFragmentFull, 'id' | 'sellerId' | 'groupId' | '_values'> | None
const props = defineProps<{
  product: ProductPartial
  onOptionChange: OnActiveItem | None
  onImage?: (img: gen.ImageNodeItemFragment | None) => void
}>()

const holder = shallowRef(props.product)
const timer = useTimeout()

watch(
  () => props.product,
  (next) => {
    if (next?._values) {
      timer.clear()
      holder.value = next
    } else {
      timer.set(() => (holder.value = undefined), 1000)
    }
  },
  { immediate: true }
)
</script>

<template>
  <ProductSelectOptions v-if="holder?._values?.options?.length" :product="holder" :on-active="onOptionChange" :on-image />
  <ProductSelectChoices v-else-if="holder?._values?.variantCount && holder?._values?.variantCount > 1" :product="holder" :on-active="onOptionChange" :on-image />
</template>
